var _style, _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTb3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000024702804383915307640000017199825265257951390_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 44,
    height: 44,
    viewBox: "0 0 42 42",
    style: {
      enableBackground: "new 0 0 42 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F9F4C7;stroke:#231F20;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#231F20;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 42,
    x: 0,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21,
    cy: 21,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,18.5c1,0,1.8-0.3,2.5-0.8s1-1.4,1-2.4c0-0.8-0.3-1.5-0.8-2.1s-1.3-0.9-2.2-0.9c-0.6,0-1.2,0.1-1.6,0.3 s-0.7,0.4-1,0.7s-0.5,0.7-0.7,1.1s-0.4,0.9-0.6,1.3c-0.1,0.2-0.3,0.4-0.6,0.5s-0.6,0.2-0.9,0.2c-0.4,0-0.8-0.2-1.1-0.5 s-0.5-0.8-0.5-1.4s0.2-1.1,0.5-1.7s0.8-1.2,1.4-1.7c0.6-0.5,1.4-1,2.4-1.3s2-0.5,3.1-0.5c1,0,1.9,0.1,2.8,0.4s1.6,0.7,2.2,1.2 s1.1,1.1,1.4,1.8s0.5,1.4,0.5,2.2c0,1-0.2,1.9-0.7,2.7s-1.1,1.5-2,2.2c0.8,0.4,1.5,0.9,2,1.5s1,1.2,1.3,1.9s0.4,1.4,0.4,2.2 c0,1-0.2,1.9-0.6,2.8s-0.9,1.7-1.7,2.4s-1.6,1.2-2.6,1.6s-2.1,0.6-3.4,0.6s-2.4-0.2-3.4-0.7s-1.8-1-2.4-1.7s-1.1-1.4-1.4-2.1 S13,27,13,26.5c0-0.6,0.2-1.1,0.6-1.5s0.9-0.5,1.5-0.5c0.3,0,0.6,0.1,0.8,0.3c0.3,0.2,0.4,0.4,0.5,0.6c0.5,1.5,1.1,2.5,1.7,3.2 s1.5,1,2.6,1c0.6,0,1.3-0.2,1.9-0.5s1.1-0.8,1.5-1.4s0.6-1.4,0.6-2.2c0-1.2-0.3-2.2-1-2.9s-1.6-1-2.8-1c-0.2,0-0.5,0-1,0.1 s-0.7,0.1-0.8,0.1c-0.6,0-1-0.1-1.3-0.4s-0.5-0.7-0.5-1.2s0.2-0.9,0.6-1.2s0.9-0.5,1.7-0.5L20.2,18.5L20.2,18.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTb3);
export default __webpack_public_path__ + "static/media/Tb3.49edde2170cfe86617a706f976d380ab.svg";
export { ForwardRef as ReactComponent };